import { TFunction } from "i18next";

export const steps = (t: TFunction) => 
    [
    {
        label: t("import/steps/import mode"),
        formKey: "insertMode"
    },
    {
        label: t("import/steps/category"),
        formKey: "category"
    },
    {
        label: t("import/steps/calculation type"),
        formKey: "calcType"
    },
    {
        label: t("import/steps/insert data"),
        formKey: "insertData"
    }
];